module.exports = __webpack_public_path__ + "static/media/kids_18.3c9c7173.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_18.jpg
// module id = 5874
// module chunks = 0